import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import ErrorToast from './ErrorToast';
import { errorRemove, deleteProject } from '../../actions';
import ProjectNotFound from './ProjectNotFound';

class ErrorsContainer extends React.Component {
    constructor() {
        super();

        this.onClose = this.onClose.bind(this);
    }

    onClose(error) {
        this.props.errorRemove(error);
    }

    renderErrors() {
        if (this.props.notFound !== null) {
            return (<ProjectNotFound />);
        }

        // if (this.props.notDriverProjects !== null) {
        //     return (<ProjectWithoutDriver />);
        // }

        let errorsList = this.props.errors.map((error, key) => {
            if (error.projectId) {
                //project to remove since this condition means that it was an error adding the driver, but the project was created anyway
                this.props.deleteProject(error.projectId)
                    .then(() => {
                        error.projectId = null;
                    })
                    .catch(error => {
                        console.error("ERROR DELETING PROJECT ---> ", error);
                    });
            }
            return (
                <ErrorToast
                    key={key}
                    error={error}
                    onClose={this.onClose} />
            )
        });

        return (
            <div style={{ minHeight: '6rem' }} >
                <div style={{ position: 'absolute', right: '1rem' }} >
                    {errorsList}
                </div>
            </div>
        );

        // return this.props.errors.map((error, key) => {
        //     return (
        //         <ErrorToast
        //             key={key}
        //             error={error}
        //             onClose={this.onClose} />
        //     )
        // });
    }

    render() {
        return (
            <div>
                {this.renderErrors()}
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        errors: state.errorsHandler.errors,
        notFound: state.errorsHandler.notFound,
        notDriverProjects: state.errorsHandler.notDriverProjects
    };
};

const mapDispatchToProps = {
    errorRemove,
    deleteProject
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorsContainer));
